import skistarImportStatus from '../../../../variables/skistarImportStatus';
import skistarImageStatus from '../../../../variables/skistarImageStatus';

export default {
  /**
   * @param state
   * @returns []
   */
  getAccommodations(state) {
    const accommodations = [];
    const importedAccommodations = [];
    state.import.status.items.forEach((stockPriceProduct) => {
      importedAccommodations.push(stockPriceProduct.xmlChannelProductId);
    });
    state.accommodations.items.forEach((accommodation) => {
      if (!state.accommodations.subarea
        || state.accommodations.subarea === accommodation.subarea.id) {
        accommodations.push({
          ...accommodation,
          imported: importedAccommodations.indexOf(accommodation.xmlChannelProductId) !== -1,
          selected: state.accommodations.selected.indexOf(accommodation.id) !== -1,
        });
      }
    });
    return accommodations.filter((accommodation) => {
      if (accommodation.imported
        && state.accommodations.filterImportStatus === skistarImportStatus.NON_IMPORTED) {
        return false;
      }
      if (!accommodation.imported
          && state.accommodations.filterImportStatus === skistarImportStatus.IMPORTED
      ) {
        return false;
      }
      if (accommodation.hasOldImagesImported
        && state.accommodations.filterImageStatus === skistarImageStatus.NEW_IMAGES) {
        return false;
      }
      if (!accommodation.hasOldImagesImported
          && state.accommodations.filterImageStatus === skistarImageStatus.OLD_IMAGES
      ) {
        return false;
      }
      if (state.accommodations.search) {
        const searchIn = accommodation.name + accommodation.areaName + accommodation.subareaName;
        if (searchIn.toLowerCase().indexOf(state.accommodations.search.toLowerCase()) === -1) {
          return false;
        }
      }

      return true;
    });
  },
  /**
   * @param state
   * @param getters
   * @returns []
   */
  getUnimportedAccommodations(state, getters) {
    return getters.getAccommodations.filter(
      accommodation => !accommodation.imported,
    );
  },
  /**
   * @param state
   * @param getters
   * @returns []
   */
  getSelectedAccommodations(state, getters) {
    return getters.getAccommodations.filter(
      accommodation => accommodation.selected,
    );
  },

  /**
   * @param state
   * @returns {[]}
   */
  getAddons(state) {
    const addons = [];
    state.addons.items.forEach((addon) => {
      if (!state.resorts.subarea.selected || addon.accommodations.findIndex(
        accommodation => accommodation.subareaId === state.resorts.subarea.selected) !== -1) {
        addons.push({ ...addon, accommodationCount: addon.accommodations.length });
      }
    });
    return addons.filter((addon) => {
      if (!state.addons.search) {
        return true;
      }
      const searchIn = addon.description;
      return searchIn.toLowerCase()
        .indexOf(state.addons.search.toLowerCase()) !== -1;
    });
  },

  /**
   * @param state
   * @returns {[]}
   */
  getResortSubareas(state) {
    return [...state.resorts.subarea.items].sort((a, b) => (a.name > b.name ? 1 : -1));
  },

  /**
   * @returns {[]}
   */
  getSkistarImportStatusItems() {
    return [
      { value: skistarImportStatus.ALL, text: 'All' },
      { value: skistarImportStatus.IMPORTED, text: 'Imported' },
      { value: skistarImportStatus.NON_IMPORTED, text: 'Non Imported' },
    ];
  },

  /**
   * @returns {[]}
   */
  getSkistarImageStatusItems() {
    return [
      { value: skistarImageStatus.ALL, text: 'All' },
      { value: skistarImageStatus.OLD_IMAGES, text: 'Old images imported' },
      { value: skistarImageStatus.NEW_IMAGES, text: 'No old images imported' },
    ];
  },

  /**
   * @param state
   * @returns {string}
   */
  getImportedAccommodationSiteName(state) {
    if (!state.accommodation.importStatus.importedAccommodation) {
      return '';
    }
    const importedToSite = state.sites.items.find(
      site => site.id === state.accommodation.importStatus.importedAccommodation.siteId,
    );
    return importedToSite ? importedToSite.name : '';
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/skistar/getters.js